import Calendar from 'js-year-calendar';
import 'js-year-calendar/locales/js-year-calendar.ru';
import 'js-year-calendar/locales/js-year-calendar.uk';

const lang = document.querySelector('body').dataset.lang;
const calendarContainer = document.querySelector('#calendar');

if (calendarContainer) {
    const minDate = new Date(parseInt(calendarContainer.dataset.date) * 1000);
    const currentDate = new Date(parseInt(calendarContainer.dataset.current) * 1000);

    let dataSource = [
        {
            startDate: currentDate,
            endDate:currentDate,
        }
    ]
    const calendar = new Calendar('#calendar', {
        language: lang == 'ua' ? 'uk' : lang,
        maxDate: new Date(),
        minDate: minDate,
        dataSource: dataSource,
        startYear: currentDate.getFullYear(),
        style:'custom',
        customDataSourceRenderer: function(element, date, event) {
            // This will override the background-color to the event's color
            element.classList.add('calendar__content__item_active');
        },
        setCustomDayRenderer: function(element, date, event) {
            // This will override the background-color to the event's color
            element.classList.add('calendar__content__item');
        },
        clickDay: function (e) {
            const month = parseInt(e.date.getMonth()) + 1;
            const visibleMonth = month >= 10 ? month : '0' + month
            const day = e.date.getDate();
            const visibleDay = day >= 10 ? day : '0' + day
            const year = e.date.getFullYear();
            let href = calendarContainer.dataset.href + '/';
            window.location.href = href + visibleDay + '.' + visibleMonth + '.' + year + '#content'
        },
        yearChanged: function (e) {
            this.startYear = e.currentYear;
        },
        renderEnd: function () {
            showMoreMonths();
        }
    });
}

function showMoreMonths() {
    if(calendarContainer) {
    const months = calendarContainer.querySelectorAll('.month-container');

        const btnShowMore = document.querySelector('.show-more');
        btnShowMore.style.display = 'flex';
        let clickNum = 1;
        let columns = 4;
        if (window.innerWidth >= 992 && window.innerWidth < 1400) {
            columns = 3;
        }
        months.forEach((m, i) => {
            if (i >= columns) {
                m.style.display = 'none';
            }
        })
        if (months && btnShowMore) {
            months.forEach((month) => {
                if (month.dataset.monthId < columns) {
                    month.style.display = 'block';
                }
            })
            btnShowMore.addEventListener('click', () => {
                clickNum += 1;
                months.forEach((month) => {
                    if (month.dataset.monthId < columns * clickNum) {
                        month.style.display = 'block';
                    }
                })
                if (columns === 3) {
                    if (clickNum === 4) {
                        btnShowMore.style.display = 'none';
                    }
                } else {
                    if (clickNum === 3) btnShowMore.style.display = 'none';
                }
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', showMoreMonths);
